// @flow
import { Description, Icons, Main, NextStep, StyledDeviceIcon, StyledIcon } from './style';
import { injectIntl, intlShape } from 'react-intl';
import { NOTIFICATIONS_ON, RIGHT } from '~/core/constants/icons/general';

import ConditionalFeature from '~/core/components/conditional-feature';
import messages from '../intl';
import PropTypes from 'prop-types';
import * as React from 'react';

const BUTTON_TEMPLATE_REGEXP = /^hive-button/i;

const propTypes = {
    active: PropTypes.bool.isRequired,
    consumerType: PropTypes.string,
    intl: intlShape,
    isNotification: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    producerType: PropTypes.string.isRequired,
    selectTemplate: PropTypes.func
};

const Template = ({
    active,
    consumerType,
    intl: { formatMessage },
    isNotification,
    name,
    producerType,
    selectTemplate = () => {}
}) => (
    <ConditionalFeature condition={featureFlags => !isHiveButton(name) || featureFlags.hiveButton}>
        {() => (
            <Main onClick={selectTemplate}>
                <Icons>
                    <StyledDeviceIcon active={active} type={producerType} />
                    <StyledIcon icon={RIGHT} />
                    {isNotification ? (
                        <StyledIcon icon={NOTIFICATIONS_ON} set={'general'} />
                    ) : (
                        <StyledDeviceIcon active={false} type={consumerType} />
                    )}
                </Icons>
                <Description>
                    <p>{formatMessage(messages[name])}</p>
                </Description>
                <NextStep>
                    <StyledIcon icon={RIGHT} />
                </NextStep>
            </Main>
        )}
    </ConditionalFeature>
);

function isHiveButton(templateName) {
    return BUTTON_TEMPLATE_REGEXP.test(templateName);
}

Template.propTypes = propTypes;

export default injectIntl(Template);



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/template/component.js